import React from "react";
import Translator from "Languages/Utility/Translator";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import {useDispatch} from "react-redux";
import {editDataSelected} from "../../../../../Stores/actions/ContractActions";
import * as Icons from "react-bootstrap-icons";

function EditRowContract({ row }) {

    const dispatch = useDispatch();

    const onEditToList = () => {
        dispatch(editDataSelected(row));
    }

    return (
        <>
            <ActionFormatter
                title={<Translator id="virayesh" />}
                icon={<Icons.Pencil size={17} />}
                className="warning-fill"
                onClick={onEditToList}
            />
        </>
    );
}

export default EditRowContract;
